export class Employee {
    id: number;
    name: string;
    lot_id: string;
    lot_name: string;
    company_id: number;
    company_name: string;
    track_id: string;
    dob: string;
    email: string;

    document_verifications: any[];
    address_verifications: any[];
    education_verifications: any[];
    employment_verifications: any[];
    icr_verifications: any[];
    identity_verifications: any[];
    reference_verifications: any[];
    pcc_verifications: any[];
    global_db_verifications: any[];

    created_at: string;
    expected_joining_date: string;
    mobile_number: string;
    father_name: string;
    client_employee_id: string;
    age: string;
    completion_date: string;
    verification_status: string;
    interim_report_date: string;
    attachments: any[];
    is_checked: boolean;
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/core/models/employee.model.ts